var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("PageHeading", {
        attrs: {
          text: "Анкеты физ. лиц",
          mode: "grid",
          "grid-data-loading": _vm.gridDataLoading,
          "results-count": _vm.resultsCount,
        },
      }),
      _c(
        "v-row",
        [_c("v-col", [_c("GridPersonalDetails", { ref: "grid" })], 1)],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }